import { Button } from '../ui/button';
import { WA_URL } from '../../lib/wa';

export const Footer = () => (
  <footer className="bg-gray-900 text-white py-12">
    <div className="container mx-auto px-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
        <div>
          <div className="flex flex-col leading-tight mb-4">
            <span className="text-xl font-bold">Atlas</span>
            <span className="text-xs text-gray-400">by Box of India</span>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed mb-3">
            Launching Indian brands into Australia & New Zealand.
          </p>
          <p className="text-gray-500 text-xs leading-relaxed">
            Atlas is built on the Box of India ecosystem.
          </p>
          <Button asChild className="mt-6 bg-[#004aad] hover:bg-[#003a8c] text-white" data-testid="footer-get-started-btn">
            <a href={WA_URL} target="_blank" rel="noopener noreferrer">Get Started</a>
          </Button>
        </div>

        <div>
          <h4 className="font-bold mb-4 text-white">Sydney Office</h4>
          <address className="text-gray-400 text-sm leading-relaxed not-italic">
            83 Beauchamp Drive<br />
            The Ponds NSW 2769<br />
            Australia
          </address>
        </div>

        <div>
          <h4 className="font-bold mb-4 text-white">Auckland Office</h4>
          <address className="text-gray-400 text-sm leading-relaxed not-italic">
            189 Godfrey Drive<br />
            Orewa 0931<br />
            New Zealand
          </address>
        </div>

        <div>
          <h4 className="font-bold mb-4 text-white">Noida Office</h4>
          <address className="text-gray-400 text-sm leading-relaxed not-italic mb-4">
            Unit 4, Film City<br />
            Sector 16<br />
            Noida, India
          </address>
          <div className="mt-4">
            <h4 className="font-bold mb-2 text-white">Email</h4>
            <a href="mailto:atlascommerce88@gmail.com" className="text-[#4a9eff] hover:text-[#6bb3ff] transition-colors text-sm">
              atlascommerce88@gmail.com
            </a>
          </div>
          <div className="mt-4">
            <h4 className="font-bold mb-2 text-white">Phone</h4>
            <a href="tel:+918130244477" className="text-[#4a9eff] hover:text-[#6bb3ff] transition-colors text-sm">
              +91 8130244477
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm">
        <p>&copy; 2026 Atlas by Box of India. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
